import React from 'react';
import PageView from '@mui/icons-material/Pageview';
import WorkspacesIcon from '@mui/icons-material/Workspaces';

export const UserSlidesSearchIcon = () => <PageView />;

export const SlideGroupsIcon = () => <WorkspacesIcon />;
